export default __webpack_public_path__ + "static/media/pic_404.393fae39.svg";